import { Controller } from "@hotwired/stimulus";

/**
 * トーストメッセージを表示する
 * @see app/views/shared/_toast.html.erb
 */
export class ToastController extends Controller {
  connect() {
    // ページ移動時にも呼ばれるので、初期化済みであれば何もしない
    if (this.element.dataset.initialized) return;
    this.element.dataset.initialized = true;

    const toast = this.element;
    // 0.5秒後にトーストメッセージを表示
    setTimeout(() => {
      toast.style.display = "block"; // メッセージを表示する
      // 画面幅が768px未満の場合
      if (window.innerWidth < 768) {
        toast.style.top = "24px"; // 画面上部に移動する
      } else {
        // 画面幅が768px以上の場合
        toast.style.right = "20px"; // 画面下部に移動する
      }
      toast.style.opacity = 1; // 不透明度を設定する

      // 6秒後にトーストを自動的に非表示にする
      setTimeout(() => {
        this.close();
      }, 6000);
    }, 500);
  }

  close() {
    this.element.style.opacity = 0;
    this.element.addEventListener(
      "transitionend",
      () => {
        this.element.style.display = "none";
      },
      { once: true },
    );
  }
}
